<section class="col-seleccion">
  <div class="tituloInt tituloPromociones">{{ 'SELECCION_BUTACAS_PARA' | translate}} {{ ' ' }} {{chNombreEspectaculo}}</div>
  <ticketing-mapa-recinto></ticketing-mapa-recinto>
</section>
<ticketing-selector-tarifas
  class="backModal enCalendar"
  id="selectorTarifas"
  style="display: none"
></ticketing-selector-tarifas>
